import React from 'react';
import { useEffect } from 'react';
import { CreditCard, Building2, TrendingUp, X } from 'lucide-react';
import { useNavigate } from 'react-router';
import ROUTES from '../../constants/RouteData';
// Replace with your logo path

export default function MobileMenu({ handleClose }) {

    const navigate = useNavigate();

useEffect(() => {
  document.body.classList.add('overflow-hidden');
  return () => {
    document.body.classList.remove('overflow-hidden');
  };
}, []);

const handleLinkClick = (link)=>{

    window.location.href = `${link}`
}



  return (
    <div className="fixed h-[100vh] inset-0 z-[9999] bg-black text-white px-4 py-5 overflow-y-auto">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-2">
          <img src='/assets/img/newLogo.png' alt="Logo" height="24"
          width="142"
         className="object-contain" />
         
        </div>
        <button onClick={handleClose} className="text-white hover:text-gray-300 transition">
          <X size={26} />
        </button>
      </div>

      {/* Menu Items */}
      <div className="flex flex-col space-y-5">
        <button
          onClick={() => handleLinkClick(ROUTES.personalLoan)}
          className="group flex items-center space-x-4 text-base font-medium hover:text-lime-300 transition-all duration-300 transform hover:scale-105"
        >
          <div className="p-2 rounded-full bg-white/10 group-hover:bg-white/20 transition-all">
            <CreditCard size={22} className="text-lime-300" />
          </div>
          <span>Personal Loan</span>
        </button>

        <button
          onClick={() => handleLinkClick(ROUTES.businessLoan)}
          className="group flex items-center space-x-4 text-base font-medium hover:text-lime-300 transition-all duration-300 transform hover:scale-105"
        >
          <div className="p-2 rounded-full bg-white/10 group-hover:bg-white/20 transition-all">
            <Building2 size={22} className="text-lime-300" />
          </div>
          <span>Business Loan</span>
        </button>

        <button
          onClick={() => window.open('https://payoff.club/','_blank')}
          className="group flex items-center space-x-4 text-base font-medium hover:text-lime-300 transition-all duration-300 transform hover:scale-105"
        >
          <div className="p-2 rounded-full bg-white/10 group-hover:bg-white/20 transition-all">
            <TrendingUp size={22} className="text-lime-300" />
          </div>
          <span>PayOff</span>
        </button>
      </div>

      {/* Optional Footer (customize or remove) */}
      <div className="mt-10 text-center text-xs text-white/70">
        Powered by DigitMoney © {new Date().getFullYear()}
      </div>
    </div>
  );
}
